import { render, staticRenderFns } from "./search-stats.vue?vue&type=template&id=3738d36c&"
import script from "./search-stats.vue?vue&type=script&lang=js&"
export * from "./search-stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports